module.exports = __webpack_public_path__ + "static/media/fxpedal.2bf2565c.svg";